import { basicSelector } from 'ContentEditorUI/redux/selectors/helpers';
export const getUploadedFeaturedImages = basicSelector(state => state.uploadedFeaturedImages);